import { render } from "./WeeklyCalendar.vue?vue&type=template&id=61e508c2"
import script from "./WeeklyCalendar.vue?vue&type=script&lang=js"
export * from "./WeeklyCalendar.vue?vue&type=script&lang=js"

import "./WeeklyCalendar.vue?vue&type=style&index=0&id=61e508c2&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__